const constants = {
  scriptQuerySelector: (chatWidgetSource: string): string =>
    `script[src="${chatWidgetSource}"]`,
};

export default constants;
